module.exports = __webpack_public_path__ + "static/media/Miltank_gaussian2.7ce37400.png";